module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-3-b35a197b591ffd60a99a8fa4e0ae25fe.png";